<div
  class="text-block-container"
  (mouseenter)="toggleIcon()"
  (mouseleave)="toggleIcon()"
  (dblclick)="toggleEditable.emit()"
  data-test="text-block-container"
>
  <div
    class="text-block-content ql-editor ql-blank"
    [ngClass]="{ placeholder: !description }"
    capraTooltip
    [tooltipContent]="placeholderText"
    [tooltipContentIsHtml]="false"
    tooltipPlacement="right"
    [tooltipIsDisabled]="readOnly || !description"
    data-test="read-only-editor"
    [innerHTML]="viewOnlyHTML"
  ></div>
  <capra-icon *ngIf="showIcon" class="hover-icon" icon="icon-pencil" data-test="hover-icon"></capra-icon>
</div>
